import { FC, useCallback, useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { AuthContext } from "src/context/authContext";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { reRouteRelevantUser } from "src/helpers/user";




const AuthCallback: FC = (): JSX.Element => {
  const { createSession } = useContext(AuthContext)
  const { showToast } = useContext(ToastContext)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()


  const getRelevantData = useCallback(() => {
    const user_data = JSON.parse(searchParams.get("user") || "{}")
    const jwt_token = decodeURIComponent((searchParams.get("jwt_token") || "").replace(/\+/g, ' '))
    const address = JSON.parse(searchParams.get("address") || "{}")
    const sub_header = JSON.parse(searchParams.get("sub_header") || "{}")

    if (jwt_token.length > 0) {
      createSession(
        {
          ...user_data,
          practice_created_date: address ? address.date : "",
          practice_name: address ? address.name : "",
          address: address ? address.ref_address : "",
        },
        sub_header,
        `bearer ${jwt_token}`
      );
      showToast(["User has been logged in"], ToastTypes.INFO);
      localStorage.setItem("fromSingleSignOn", "true")
      const relevantRoute = reRouteRelevantUser(user_data, true);
      navigate(relevantRoute)
    } else {
      showToast(["No user found in our system"], ToastTypes.ERROR)
      localStorage.clear()
      navigate("/users/sign_in")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getRelevantData()
  }, [getRelevantData])


  return (
    <div style={{ textAlign: 'center', marginTop: '20%' }}>
      <h1>Authenticating...</h1>
      <p>Please wait while we log you in.</p>
      <span className="spinner-border spinner-border-sm" style={{ width: 30, height: 30 }} aria-hidden="true"></span>
    </div>
  )
}

export default AuthCallback
